import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { articleActions, hasChanged } from 'features/articles'
import Editor from './Editor'

class EditorContainer extends PureComponent {
	onArticleChange = ({ title, value }) => {
		const { changeEditorTitle, changeEditorContent } = this.props

		if (title || title === '') {
			changeEditorTitle(title)
		}

		// Check if value contains placeholder data to prevent setting hasChanged flag
		// Data may differ to `placeholderData` from editor-data.js because editor adds empty paragraph at the end
		if (
			(value || value === '') &&
			JSON.stringify(value).indexOf('"type":"paragraph-placeholder"') ===
				-1
		) {
			changeEditorContent(value)
		}
	}

	render() {
		const {
			article,
			article: {
				id,
				editorTitle,
				editorContent,
				createdAt,
				createdBy,
				updatedAt,
				updatedBy,
				ratings,
				responsibleMembers,
				draft,
				outdated,
				lockedBy,
			},
			userProfile,
			hasChanged,
			updateArticle,
			removeArticle,
			changeArticleState,
			changeOutdatedState,
			duplicateArticle,
			unlockArticle,
			rateArticle,
			location,
			loading,
		} = this.props

		return (
			<Editor
				// readOnly={userProfile.role === 100}
				meta={{
					id,
					createdAt,
					createdBy,
					updatedAt,
					updatedBy,
					ratings,
					responsibleMembers,
					userId: userProfile.id,
				}}
				onChange={this.onArticleChange}
				id={id}
				draft={draft || false}
				outdated={outdated || false}
				lockedBy={lockedBy}
				title={editorTitle}
				value={editorContent}
				isUnsaved={hasChanged}
				onSave={updateArticle}
				onDraftStateChange={changeArticleState}
				onChangeOutdatedState={changeOutdatedState}
				onRemove={removeArticle}
				onRate={rateArticle}
				onDuplicate={duplicateArticle}
				onUnlock={unlockArticle}
				location={location}
				loading={article.loading}
			/>
		)
	}
}

const mapStateToProps = state => ({
	article: state.articles.article,
	userProfile: state.auth,
	hasChanged: hasChanged(state),
})

const mapDispatchToProps = {
	changeEditorTitle: articleActions.changeEditorTitle,
	changeEditorContent: articleActions.changeEditorContent,
	updateArticle: articleActions.updateArticleRequest,
	removeArticle: articleActions.removeArticleRequest,
	changeArticleState: articleActions.changeArticleStateRequest,
	changeOutdatedState: articleActions.changeOutdatedStateRequest,
	duplicateArticle: articleActions.duplicateArticleRequest,
	unlockArticle: articleActions.unlockArticleRequest,
	rateArticle: articleActions.rateArticleRequest,
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(EditorContainer)
)
